export default __webpack_public_path__ + "static/media/main-bottomimg2.04bd7672.png";